import { KeepSelection } from "@/actions/selection/keep-selection"
import {
    CheckoutAPIProduct,
    RelatedProduct
} from "@/types/centra/checkout-api/products/post-products"
import { ProductData } from "@/lib/content-service/types/ContentServiceProduct"

interface SuccessKeepSelection {
    readonly _tag: "success"
    readonly success: true
    readonly data: KeepSelection
}

const helperSizeGuide = (
    product: CheckoutAPIProduct | RelatedProduct | ProductData,
    selectionData: SuccessKeepSelection | null | undefined
): { sizeGuideImageUrl: string | undefined } => {
    const languageCode =
        selectionData?.data.checkoutApiSelection?.location?.language?.language.toUpperCase()
    let sizeGuideImageUrl: string | undefined
    switch (languageCode) {
        case "US":
            sizeGuideImageUrl = product?.size_guide_type?.image_en_US?.url
            break
        case "FR":
            sizeGuideImageUrl = product?.size_guide_type?.image_fr?.url
            break
        case "DE":
            sizeGuideImageUrl = product?.size_guide_type?.image_de?.url
            break
        case "JP":
            sizeGuideImageUrl = product?.size_guide_type?.image_ja?.url
            break
        default:
            sizeGuideImageUrl = product?.size_guide_type?.image?.url
    }

    return { sizeGuideImageUrl }
}

export default helperSizeGuide
